export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-gradient-to-br from-primary-500/5 to-accent-500/5 rounded-3xl p-8 md:p-12 lg:p-16 border border-background-200/70">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">皮皮漫画 APP下载</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
              随时随地畅享皮皮漫画韩漫、日漫与国漫的精彩内容。APP支持离线下载、夜间模式、自动翻页等实用功能，阅读体验更流畅，更新推送第一时间送达。
            </p>
            <ul className="mt-6 space-y-3 text-sm text-foreground-600 max-w-md mx-auto lg:mx-0">
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-accent-500 text-lg mt-0.5 shrink-0"></i>
                <span>高清画质自适应，支持横竖屏切换阅读</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-accent-500 text-lg mt-0.5 shrink-0"></i>
                <span>离线缓存功能，无网络也能畅快阅读</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-accent-500 text-lg mt-0.5 shrink-0"></i>
                <span>智能推荐算法，发现更多合口味的漫画</span>
              </li>
            </ul>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-foreground-950 hover:bg-foreground-800 text-background-50 font-medium text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
          <div className="flex-1 w-full max-w-[360px]">
            <div className="relative w-full aspect-[3/4] rounded-2xl overflow-hidden bg-background-200 shadow-sm">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20colorful%20manga%20comic%20reading%20app%20interface%20with%20Korean%20webtoon%20style%20thumbnails%2C%20clean%20modern%20UI%20design%2C%20warm%20orange%20and%20coral%20accent%20colors%2C%20comic%20cover%20grid%20layout%2C%20soft%20device%20shadow%2C%20minimal%20background%2C%20app%20store%20promotional%20style&width=720&height=960&seq=app-mockup-01&orientation=portrait"
                alt="皮皮漫画APP界面展示"
                title="皮皮漫画APP"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}